import React from 'react';
import { Box, Typography, Paper, Grid } from '@mui/material';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import TimerOutlinedIcon from '@mui/icons-material/TimerOutlined';

export const BannerInfoReglasProgramacion = () => {
  return (
    <Paper
      elevation={0}
      sx={{
        mt: 3,
        p: { xs: 3, md: 4 },
        backgroundColor: '#F8F7FA', // Color de fondo muy suave
        borderRadius: 3,
        border: '1px solid #EAEAFF',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-start',
          mb: 4,
          flexWrap: 'wrap',
          gap: 2,
        }}
      >
        <Box sx={{ display: 'flex', gap: 2, flex: 1, minWidth: '300px' }}>
          <Box
            sx={{
              width: 52,
              height: 52,
              borderRadius: '50%',
              backgroundColor: '#E8E7FD',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              flexShrink: 0,
            }}
          >
            <AutoAwesomeIcon sx={{ color: '#696CFF', fontSize: 28 }} />
          </Box>
          <Box>
            <Typography
              variant="h6"
              sx={{ color: '#696CFF', fontWeight: 700, mb: 0.5, fontSize: '1.15rem' }}
            >
              ¿Para qué sirven las reglas de programación?
            </Typography>
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{ fontWeight: 500, maxWidth: '80%' }}
            >
              Establece restricciones y límites para la asignación de turnos, asegurando el
              cumplimiento de políticas laborales y operativas por cargo.
            </Typography>
          </Box>
        </Box>
      </Box>

      <Grid container spacing={3} sx={{ pl: { xs: 0, sm: 8.5 } }}>
        <Grid size={{ xs: 12, md: 4 }}>
          <Box sx={{ display: 'flex', gap: 1.5 }}>
            <AccessTimeOutlinedIcon sx={{ color: '#696CFF', fontSize: 28 }} />
            <Box>
              <Typography
                variant="subtitle2"
                sx={{ fontWeight: 700, color: 'text.primary', mb: 0.5 }}
              >
                Control de Horas
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 500 }}>
                Define el máximo de horas semanales permitidas por cargo para evitar sobretiempos.
              </Typography>
            </Box>
          </Box>
        </Grid>
        <Grid size={{ xs: 12, md: 4 }}>
          <Box sx={{ display: 'flex', gap: 1.5 }}>
            <TimerOutlinedIcon sx={{ color: '#696CFF', fontSize: 28 }} />
            <Box>
              <Typography
                variant="subtitle2"
                sx={{ fontWeight: 700, color: 'text.primary', mb: 0.5 }}
              >
                Descansos Obligatorios
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 500 }}>
                Configura el tiempo mínimo de descanso requerido entre turnos consecutivos.
              </Typography>
            </Box>
          </Box>
        </Grid>
        <Grid size={{ xs: 12, md: 4 }}>
          <Box sx={{ display: 'flex', gap: 1.5 }}>
            <CalendarMonthOutlinedIcon sx={{ color: '#696CFF', fontSize: 28 }} />
            <Box>
              <Typography
                variant="subtitle2"
                sx={{ fontWeight: 700, color: 'text.primary', mb: 0.5 }}
              >
                Días Consecutivos
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 500 }}>
                Limita la cantidad máxima de días de trabajo consecutivos permitidos.
              </Typography>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Paper>
  );
};
